import { push, RouterAction } from "connected-react-router";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { Template } from "@xapp/ovai-lib";

import { isLoading, State } from "redux/state";
import {
    NavDrawer,
    NavDrawerDispatchProps as DispatchProps,
    NavDrawerOwnProps as OwnProps,
    NavDrawerStateProps as StateProps
} from "../components/NavDrawer";

import { authChangePerspective, AuthChangePerspectiveAction } from "auth";
import { CREATE_APP, createApp, CreateAppAction, selectApp, SelectAppAction, UPLOAD_TEMPLATE, uploadTemplate, UploadTemplateAction } from "routes/App/modules";
import { openExternalURL } from "utils/Utils";
import { ClientApp } from "models";

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
    dispatch: ThunkDispatch<
        State,
        undefined,
        AuthChangePerspectiveAction |
        CreateAppAction |
        UploadTemplateAction |
        RouterAction |
        SelectAppAction
    >
) => {
    return {
        onChangePerspective(asUser: boolean) {
            dispatch(authChangePerspective(asUser));
        },

        onCreateApp(app: ClientApp) {
            dispatch(createApp(app));
        },

        onCreateTemplate(template: Template) {
            dispatch(uploadTemplate(template, true));
        },

        onExternalClick(url: string) {
            openExternalURL(url);
        },

        onNavClick(path: string) {
            dispatch(selectApp(undefined));
            dispatch(push(path));
        }
    };
};

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => {
    return {
        asUser: state.auth.asUser,
        isCreatingApp: isLoading(state, CREATE_APP) || isLoading(state, UPLOAD_TEMPLATE),
        profile: state.auth.profile
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NavDrawer);
